import {
    getDocumentVersions,
    getDraftState,
    getDocumentVersionDetail,
    reconstructDocumentVersion,
    captureDocumentChanges,
    discardDocumentDraft,
    restoreDocumentVersion,
    resetDocumentVersions,
} from './documentVersion.action';

export { documentVersionReducer } from './documentVersion.reducer';
export { watchDocumentVersion } from './documentVersion.saga';

export const documentVersionActions = {
    getDocumentVersions,
    getDraftState,
    getDocumentVersionDetail,
    reconstructDocumentVersion,
    captureDocumentChanges,
    discardDocumentDraft,
    restoreDocumentVersion,
    resetDocumentVersions,
};
